// Importing necessary modules from the 'three' library and other dependencies
import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import { gsap, Expo, Cubic } from 'gsap';
import { Global } from '../common/global';

// Constants for camera position and orientation
const INITIAL_CAMERA_POSITION = new THREE.Vector3(-130, 20, -10);
const INITIAL_LOOK_AT_POSITION = new THREE.Vector3(100, 20, -10);

// Constants for camera follow lerping factors
const CAMERA_FOLLOW_LERP_X = 0.5;//0.5*0.5;
const CAMERA_FOLLOW_LERP_Y = 0.1;//0.1;
const CAMERA_FOLLOW_LERP_Z = 0.5;//0.25;

// Constant for additional padding on Y-axis when looking at the player's car
const CAMERA_LOOKAT_Y_PADD = 1.5;



// Constants for default camera shake value
const DEFAULT_SHAKE_VALUE = { 'value': 0.0 };

// Camera class definition, extending THREE.PerspectiveCamera
export default class Camera extends THREE.PerspectiveCamera {
    // Vector3 instances for lerping camera position
   
    skyLookFactor= new THREE.Vector3(0,2,-5)
    lerpZReduce=0;
    lastCameraPosition=INITIAL_CAMERA_POSITION.clone()
    // Flag indicating whether the game has started
    gameStarted = false;

    // Constructor with fov, ratio, near, and far parameters
    constructor(scene, fov, ratio, near, far) {
        super(fov, ratio, near, far);
        this.scene=scene;

        this.layers.set(0);
    }

    // Initialization method for setting up event listeners and initial camera state
    init() {
        // Getting the event dispatcher instance
        this.events = EventDispatcher.getObj();

        // Adding event listeners for different event types
        this.events.addEventListener("CAMERA_EVENTS", this.onEvents.bind(this));
        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
        this.events.addEventListener("PLAYER_EVENTS", this.onEvents.bind(this));
        this.events.addEventListener("GAME_EVENTS", this.onEvents.bind(this));

 

        // Setting initial camera position
        this.position.copy(INITIAL_CAMERA_POSITION);

        // Initializing lerping vectors for smooth camera follow

        this.initCameraFixed = false;

        // Initializing shake value
        this.shakeVal = DEFAULT_SHAKE_VALUE;

        // Setting initial look-at position
        this.lookAt(INITIAL_LOOK_AT_POSITION);



        // this.overlayCamera = new THREE.PerspectiveCamera(50, Global.sizes.width / Global.sizes.height, 400, 4000);
        // this.scene.add(this.overlayCamera);
        // this.overlayCamera.layers.set(100);
       
    }

    // Event handler for various events
    onEvents(data) {
        switch (data['message']['event_type']) {
            case "reset_game":
                this.reset();
                break;
            case "resize":
                this.onResize(data['message']['data']);
                break;
            case "update":
                this.update();
                break;
            case "move_player":
                this.smoothFollowPlayer(data['message']['data']);
                break;
            case "shake_camera":
                this.prepareToShake(data['message']['data']);
                break;
            case "pan_camera":
                this.panToFocusGame();
                setTimeout(()=>{
                    document.querySelector(".tint").classList.add('active')
                },0)
                break;
            case "start_game":
                this.gameStarted = true;
                this.initCameraFixed = false;
                // this.panToFocusGame();
                break;
            case "dispose":
                this.initCameraFixed = false;
                break;
            case "game_over":
                this.onLevelCompleted();
                break;
            case "reset_camera":
                this.resetCamera();
        }
    }

    reset() {
        this.initCameraFixed = false;
        this.position.copy(INITIAL_CAMERA_POSITION);
        this.lookAt(INITIAL_LOOK_AT_POSITION);
    }

    // Event handler for window resize
    onResize(data) {
        this.aspect = data.aspect;
        this.updateProjectionMatrix();
    }

    // Update method (currently empty, can be used for additional logic)
    update() {
        // ...
    }
    onLevelCompleted(){
        const lerpZ={
            value:0
        };
        let tween = gsap.to(lerpZ, {value: CAMERA_FOLLOW_LERP_Z-0.001, duration: 0.25, ease: "power1.inOut", onUpdate:function(){
            this.lerpZReduce=lerpZ.value;
           
        }.bind(this)});

        
    }

    // Method for smoothly following the player's car
 // Method for smoothly following the player's car
smoothFollowPlayer(data) {
    var cameraOffset = new THREE.Vector3(0, Global.vehicleType==="Truck"?1.5:1.15, 3);
    var carDirection = new THREE.Vector3(0, 0, 1.5);
    var cameraPosition = new THREE.Vector3();
    
    cameraPosition.copy(data.entity.position).add(this.skyLookFactor);
    cameraPosition.add(carDirection.clone().applyQuaternion(data.entity.quaternion).multiplyScalar(cameraOffset.z));
    cameraPosition.add(data.entity.up.clone().multiplyScalar(cameraOffset.y));
    cameraPosition.add(new THREE.Vector3(0, 0, 0).clone().multiplyScalar(cameraOffset.x));

   
    let distanceLerpX = this.position.clone().lerp(cameraPosition.clone(), 
        (!this.initCameraFixed ? 1 : Math.min(1, Math.max(0, CAMERA_FOLLOW_LERP_X - this.lerpZReduce) * Math.min(1, Math.max(.1, Math.pow(data.speed*.7 + .25, 1.5))) * Global.delta))
    ).x;

    let distanceLerpY = this.position.clone().lerp(cameraPosition, 
        !this.initCameraFixed ? 1 : Math.min(1, CAMERA_FOLLOW_LERP_Y * Global.delta + (cameraPosition.x < this.position.x ? (this.position.x - cameraPosition.x) / 30 * Global.delta : 0))
    ).y;

    let distanceLerpZ = this.position.clone().lerp(cameraPosition, 
        !this.initCameraFixed ? 1 : Math.min(1, Math.max(0, CAMERA_FOLLOW_LERP_Z - this.lerpZReduce) * Global.delta)
    ).z;

    this.position.set(distanceLerpX, distanceLerpY, distanceLerpZ);

    // Calculate speed-based shake intensity
    const carSpeed = data.speed; // Assuming the car's velocity is available in the data
    const maxShakeIntensity = 0.015; // Maximum shake intensity when the car is at top speed
    const shakeIntensity = Math.min(maxShakeIntensity, carSpeed * 0.06); // Adjust the multiplier to control the shake sensitivity

    // Additional shake from collision events (shakeVal.value)
    const collisionShake = this.shakeVal.value * 0.2; // Adjust multiplier as needed

    // Apply speed-based and collision-based shake
    const shakeFact = new THREE.Vector3(
        (Math.random() * 0.3 * (Global.boostActivated?3:1) * (shakeIntensity + collisionShake) - (shakeIntensity + collisionShake) / 2),
        (Math.random() * 0.3 * (Global.boostActivated?3:1) * (shakeIntensity + collisionShake) - (shakeIntensity + collisionShake) / 2),
        (Math.random() * 0.3 * (Global.boostActivated?3:1) * (shakeIntensity + collisionShake) - (shakeIntensity + collisionShake) / 2) * 0
    );

    this.position.add(shakeFact);

    // Setting camera orientation to look at the player's car
    let pos = data.entity.position.clone();
    this.lookAt(new THREE.Vector3(pos.x + shakeFact.x, pos.y + CAMERA_LOOKAT_Y_PADD + shakeFact.y+this.skyLookFactor.y*0.75, pos.z + shakeFact.z+this.skyLookFactor.z));

    this.lastCameraPosition = this.position.clone();
    this.initCameraFixed = true;


 
}
   
    panToFocusGame(){
        this.skyLookFactor= new THREE.Vector3(0,2,-5)
        gsap.to(this.skyLookFactor, {
            y:0,
            z:0,
            duration:4,
            ease:'power1.inOut'
        })
    }
    // Method to prepare for camera shake animation
    prepareToShake(data) {
        if (Global.gameOver) return false;
        this.shakeVal = { 'value': data['intensity']*0.25 };

        // Using gsap to animate the shake effect
        gsap.to(this.shakeVal, {
            duration: data['shake_time']/10,
            delay: 0,
            value: 0,
            yooyo:true,
            repeat: 10,
            // ease: "linead.inOut",
            onUpdate: function () { }.bind(this)
        });
    }
    resetCamera(){
        this.initCameraFixed=false;
        this.lastCameraPosition=INITIAL_CAMERA_POSITION.clone()
        this.skyLookFactor= new THREE.Vector3(0,2,-5)
        this.lerpZReduce=0;
        document.querySelector(".tint").classList.remove('active')
        setTimeout(()=>{
            this.panToFocusGame();
        },0)
    }
}